module.exports = __webpack_public_path__ + "img/Drivers_Agricultural_Conditions.466e57cb.jpg";